var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 106,
    viewBox: "0 0 139 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5401_7277)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.9843,
    cy: 13.1474,
    r: 11.5039,
    fill: "#FEBE39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.8217,
    cy: 80.938,
    r: 6.16279,
    fill: "#FEBE39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.17047,
    cy: 66.1473,
    r: 2.05426,
    fill: "#FFA603"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4884,
    cy: 64.0932,
    r: 4.10853,
    fill: "#7645D1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.698,
    cy: 38.6202,
    r: 2.46512,
    fill: "#4D6F0E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.7209,
    cy: 72.3102,
    r: 23.0078,
    fill: "#FEBE39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.279,
    cy: 21.7752,
    r: 5.34109,
    fill: "#FEBE39"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5401_7277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.078 36.3709C113.078 36.3709 110.45 36.9743 107.818 43.9837C105.598 49.8964 98.9308 53.1945 96.8949 54.0865C96.5978 54.2156 96.2948 54.326 95.9857 54.4238C94.5281 54.8709 88.4661 57.1902 88.1971 64.7168C87.897 73.2775 95.6827 74.0847 95.6827 74.0847C95.6827 74.0847 106.448 76.5369 115.443 62.8571C122.073 52.7703 120.528 43.5946 120.425 39.8619C120.371 37.9256 119.148 36.1736 117.309 35.5711C116.15 35.1901 114.701 35.2304 113.078 36.3709Z",
    fill: "#571833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.356 34.4815C116.356 34.4815 112.129 34.3898 110.967 37.3112C110.967 37.3112 112.316 37.9 114.31 36.6999C114.31 36.6999 113.646 38.2619 113.989 40.0037C113.989 40.0037 115.727 39.7068 116.706 37.4537C116.706 37.4537 116.482 39.7213 117.964 40.9522C117.964 40.9522 118.986 40.3339 118.772 37.6713C118.775 37.6931 119.256 40.3721 121.18 40.28C121.18 40.28 121.552 37.2504 118.192 34.7329L116.353 34.4784L116.356 34.4815Z",
    fill: "#4D6F0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.248 35.0455C116.276 34.4432 116.927 32.471 118.45 32.0279C118.622 31.9777 118.814 32.0117 118.968 32.1072L119.755 32.6038C119.863 32.6706 119.864 32.8229 119.76 32.8928C119.246 33.2329 118.061 34.1626 118.144 35.4096C118.16 35.6149 117.971 35.7736 117.776 35.7179L116.458 35.3314C116.332 35.2953 116.246 35.1759 116.252 35.0424L116.248 35.0455Z",
    fill: "#4D6F0E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5401_7277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.651 24.6512C108.189 24.6512 111.868 20.9723 111.868 16.4341C111.868 11.896 108.189 8.21707 103.651 8.21707C99.113 8.21707 95.4341 11.896 95.4341 16.4341C95.4341 20.9723 99.113 24.6512 103.651 24.6512Z",
    fill: "#909E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.684 12.2538C103.684 12.2538 102.4 13.6638 103.697 14.9522C103.697 14.9522 104.872 13.6261 103.684 12.2538Z",
    fill: "#BAC129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.835 13.3155C100.835 13.3155 100.751 15.2208 102.572 15.3803C102.572 15.3803 102.627 13.6093 100.835 13.3155Z",
    fill: "#BAC129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1899 16.421C99.1899 16.421 100.6 17.7009 101.888 16.4042C101.888 16.4042 100.558 15.2291 99.1899 16.421Z",
    fill: "#BAC129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.684 20.6092C103.684 20.6092 102.4 19.1991 103.697 17.9107C103.697 17.9107 104.872 19.2369 103.684 20.6092Z",
    fill: "#BAC129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.835 19.5517C100.835 19.5517 100.751 17.6464 102.572 17.4869C102.572 17.4869 102.627 19.2579 100.835 19.5517Z",
    fill: "#BAC129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.467 13.3155C106.467 13.3155 106.551 15.2208 104.73 15.3803C104.73 15.3803 104.675 13.6093 106.467 13.3155Z",
    fill: "#BAC129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.108 16.421C108.108 16.421 106.698 17.7009 105.409 16.4042C105.409 16.4042 106.74 15.2291 108.108 16.421Z",
    fill: "#BAC129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.467 19.5517C106.467 19.5517 106.551 17.6464 104.73 17.4869C104.73 17.4869 104.675 19.2579 106.467 19.5517Z",
    fill: "#BAC129"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_5401_7277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1465 16.8455C55.8821 16.1585 55.1367 10.9939 55.1367 10.9939L60.055 8.35631L65.0013 13.5255L56.1507 16.8436L56.1465 16.8455Z",
    fill: "#899414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2624 12.3584C57.1119 12.2607 56.9662 12.1406 56.8414 12.0109C56.788 11.9494 56.7427 11.8944 56.6935 11.8311L56.6268 11.7404L56.5879 11.6774L56.51 11.5515C56.4848 11.5075 56.4654 11.476 56.4481 11.4384L56.3984 11.3299C56.3556 11.2585 56.3289 11.2001 56.2983 11.1333C56.1816 10.8786 56.0949 10.6455 56.0063 10.4083C55.8413 9.93834 55.7067 9.47973 55.5865 9.01957C55.3543 8.09545 55.1858 7.16741 55.1105 6.21186C55.037 5.26049 55.0506 4.27933 55.2877 3.2917C55.4103 2.8011 55.5966 2.3066 55.8937 1.86735C56.1848 1.42584 56.5947 1.04603 57.0512 0.811612L57.5707 1.59392C57.0404 2.08448 56.8702 2.77876 56.8892 3.51258C56.9102 4.25058 57.0962 5.01905 57.3629 5.76572C57.6253 6.51431 57.9723 7.24945 58.3615 7.94501C58.557 8.29487 58.7673 8.63294 58.9805 8.94441C59.0903 9.09615 59.196 9.2498 59.3007 9.36851C59.3243 9.39809 59.354 9.42995 59.3738 9.45118L59.4096 9.48531C59.4096 9.48531 59.4313 9.51072 59.4355 9.50881L59.4537 9.51561L59.4575 9.52396C59.4575 9.52396 59.454 9.50536 59.4483 9.49283C59.4387 9.47196 59.4269 9.45717 59.4071 9.43593C59.3241 9.34264 59.2203 9.25888 59.1097 9.19336L57.2465 12.3456L57.2624 12.3584Z",
    fill: "#899414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4318 12.8849C59.4318 12.8849 56.8538 13.7631 56.5656 16.3754C56.5656 16.3754 54.4026 14.0831 50.2067 17.8799C50.2067 17.8799 45.4771 17.6881 43.4427 22.6312C41.4022 27.572 43.709 35.6935 48.6434 41.54C53.5779 47.3865 60.5883 48.084 64.214 43.8009C64.214 43.8009 68.099 44.8192 70.7181 41.6793C70.7181 41.6793 74.9786 42.9347 76.9499 38.2277C76.9499 38.2277 81.0441 37.2962 83.0072 33.4719C83.0072 33.4719 85.7342 33.2376 88.1943 30.509C90.6544 27.7804 90.5405 19.72 86.6357 13.7805C82.731 7.84101 79.5159 4.31836 72.9666 5.18767C72.9666 5.18767 70.7722 5.55166 68.4107 8.46241C68.4107 8.46241 65.1443 8.26689 63.4876 12.6278C63.4876 12.6278 62.0987 11.5416 59.4318 12.8849Z",
    fill: "#FF7C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5656 16.3753C56.5656 16.3753 56.4 25.3417 64.2978 35.392C64.2978 35.392 55.0784 28.5993 55.5023 15.8017L56.5656 16.3753Z",
    fill: "#CC632C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2049 17.8755C50.2049 17.8755 47.0832 24.4231 54.6527 36.1191C54.6527 36.1191 46.1225 28.0508 49.06 17.9809L50.209 17.8736L50.2049 17.8755Z",
    fill: "#CC632C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4771 12.572C63.4771 12.572 71.0698 17.3419 75.1479 29.4607C75.1479 29.4607 74.9783 18.0817 64.0452 11.4277L63.4771 12.572Z",
    fill: "#CC632C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4125 8.46634C68.4125 8.46634 75.4024 9.04193 81.0401 21.7847C81.0401 21.7847 79.3545 10.5144 69.3246 7.45738L68.4145 8.47052L68.4125 8.46634Z",
    fill: "#CC632C"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_5401_7277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4028 15.9293C37.8808 19.2808 35.4251 23.4746 30.8901 25.2934C26.3638 27.1186 21.4949 25.8726 20.0018 22.523C18.5238 19.1715 20.9945 14.9757 25.5207 13.1505C30.047 11.3253 34.9159 12.5713 36.409 15.9209L36.4028 15.9293Z",
    fill: "#909E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4691 15.543C28.6283 15.8957 27.2345 16.8067 25.3618 17.5585C23.4891 18.3103 21.842 18.6293 21.6828 18.2766C21.5299 17.9155 22.9174 17.0129 24.7901 16.2611C26.6628 15.5093 28.3099 15.1902 28.4691 15.543Z",
    fill: "#5D103A"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_5401_7277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.313 90.1491C106.127 86.6164 100.489 86.6104 100.489 86.6104C100.489 86.6104 96.526 82.6011 93.1781 84.2349C89.8264 85.8708 88.5905 90.6108 89.3014 94.6877C90.0124 98.7647 94.6031 100.685 94.6031 100.685C94.6031 100.685 99.1938 102.605 102.595 100.249C105.997 97.8928 108.502 93.6856 107.313 90.1491Z",
    fill: "#F75A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.158 87.4046C100.158 87.4046 98.9202 85.9319 96.8273 85.4923C96.8273 85.4923 98.2911 86.3883 98.9217 87.3532L95.9061 88.5008L99.1363 88.3279L98.0977 90.8696L99.7937 88.9145L101.229 91.1707L100.789 88.7615C100.789 88.7615 102.085 88.4496 104.05 89.3212C104.05 89.3212 103.248 87.9745 100.156 87.4104L100.158 87.4046Z",
    fill: "#4B621A"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_5401_7277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7009 91.4048C53.8065 91.3765 53.9743 91.3881 54.063 91.4313C54.697 91.7039 55.1647 92.2013 55.6772 92.6351C59.0474 95.8025 62.0408 99.2921 64.8244 102.997L62.765 104.357C61.4753 102.155 60.0392 100.003 58.5319 97.9115C57.057 95.9602 55.6499 93.8775 53.8271 92.2406C53.8014 92.2218 53.7832 92.2112 53.7832 92.2112C53.788 92.21 53.7588 92.1972 53.7976 92.2074C53.835 92.2128 53.876 92.2121 53.9071 92.1935L53.6974 91.4109L53.7009 91.4048Z",
    fill: "#919A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0985 91.6525L78.1645 103.504L76.5354 106.22L55.6834 92.3504L56.0985 91.6525Z",
    fill: "#919A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5148 89.2822C62.57 91.6835 69.7481 94.0826 77.1111 95.2899L76.7714 97.3827C72.9923 96.6457 69.3777 95.5044 65.7547 94.2933C62.1618 93.0793 58.6238 91.7631 55.105 90.3646L55.5161 89.287L55.5148 89.2822Z",
    fill: "#919A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6043 85.9992C60.6043 85.9992 56.208 94.9423 54.0078 97.6777C54.0078 97.6777 32.8856 84.452 19.3807 69.4837C19.1755 69.2556 19.1566 68.9159 19.2834 68.6401C19.459 68.2586 19.8984 68.0739 20.2962 68.2143C24.7172 69.7725 50.5963 79.2227 60.6056 86.004L60.6043 85.9992Z",
    fill: "#F87F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3939 94.0102L51.3432 88.213L47.7518 93.6111L48.3939 94.0102Z",
    fill: "#DA6329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1979 88.004L43.1485 82.2116L39.5606 87.6035L40.1979 88.004Z",
    fill: "#DA6329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5237 80.9552L48.0644 86.462L50.85 80.6109L51.5237 80.9552Z",
    fill: "#DA6329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0647 76.0032L36.6066 81.5148L39.3922 75.6637L40.0647 76.0032Z",
    fill: "#DA6329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0028 81.5032L34.9521 75.706L31.3655 81.1027L32.0028 81.5032Z",
    fill: "#DA6329"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_5401_7277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4482 42.3799L10.6191 46.7987L12.2317 50.7041C12.2317 50.7041 16.631 57.9741 25.0476 57.4922C31.5404 57.1228 34.6194 53.4968 35.6944 51.8617C36.0858 51.8121 38.1133 51.4833 38.3161 50.0824C38.4292 49.3077 37.5004 48.7311 36.5479 48.3528L36.5573 48.2807C36.5573 48.2807 35.6756 41.8574 27.7211 39.1953C19.7666 36.5332 13.453 42.3754 13.453 42.3754L13.4482 42.3799Z",
    fill: "#F9C63B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9397 46.6097C10.322 46.6007 9.72317 46.6412 9.1102 46.7268C8.50194 46.8124 7.89368 46.9385 7.29014 47.1547C6.69131 47.3709 6.08777 47.6637 5.57853 48.1547C5.32391 48.3979 5.09287 48.6862 4.93727 49.0195C4.77695 49.3483 4.67793 49.7087 4.6355 50.069L6.14435 50.1141C6.11606 49.6997 6.21508 49.2943 6.49799 48.9249C6.77147 48.5511 7.20055 48.2312 7.6815 47.97C8.16245 47.7087 8.69998 47.5015 9.25165 47.3349C9.80333 47.1727 10.3833 47.0421 10.9538 46.961L10.935 46.6187L10.9397 46.6097Z",
    fill: "#4D6F0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.619 46.8033C10.619 46.8033 7.12035 52.2807 13.8819 56.0103C13.8819 56.0103 16.6403 49.7762 10.619 46.8033Z",
    fill: "#4D6F0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6192 46.8032C10.6192 46.8032 8.52564 38.5962 20.6342 36.1548C20.6342 36.1548 21.7611 46.4924 10.6239 46.8032H10.6192Z",
    fill: "#4D6F0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9619 49.1681C27.2543 48.9969 27.6315 49.087 27.8107 49.3618C27.9899 49.641 27.9003 50.0014 27.6079 50.1726C27.3156 50.3437 26.9384 50.2536 26.7592 49.9789C26.58 49.6996 26.6696 49.3392 26.9619 49.1681Z",
    fill: "#D2982A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4855 45.3665C26.5893 45.6773 26.4101 46.0106 26.0895 46.1097C25.7641 46.2088 25.4199 46.0377 25.3114 45.7269C25.2077 45.4161 25.3869 45.0827 25.7075 44.9836C26.0329 44.8845 26.3771 45.0557 26.4855 45.3665Z",
    fill: "#D2982A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7714 46.6773C31.8751 46.9881 31.696 47.3214 31.3753 47.4205C31.05 47.5196 30.7058 47.3485 30.5973 47.0377C30.4936 46.7269 30.6728 46.3935 30.9934 46.2944C31.3188 46.1953 31.663 46.3665 31.7714 46.6773Z",
    fill: "#D2982A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0663 53.6232C25.1701 53.934 24.9909 54.2673 24.6703 54.3664C24.3449 54.4655 24.0007 54.2944 23.8923 53.9836C23.7885 53.6728 23.9677 53.3394 24.2883 53.2403C24.6137 53.1412 24.9579 53.3124 25.0663 53.6232Z",
    fill: "#D2982A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3467 50.7807C32.4269 51.015 32.2902 51.2672 32.045 51.3438C31.7998 51.4204 31.5357 51.2897 31.4556 51.0555C31.3754 50.8213 31.5122 50.569 31.7573 50.4925C32.0025 50.4159 32.2666 50.5465 32.3467 50.7807Z",
    fill: "#D2982A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6236 49.79C23.7038 50.0242 23.567 50.2764 23.3218 50.353C23.0766 50.4296 22.8126 50.299 22.7324 50.0647C22.6523 49.8305 22.789 49.5783 23.0342 49.5017C23.2794 49.4251 23.5434 49.5557 23.6236 49.79Z",
    fill: "#D2982A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0172 54.4023C30.0973 54.6365 29.9606 54.8888 29.7154 54.9654C29.4702 55.0419 29.2061 54.9113 29.126 54.6771C29.0458 54.4429 29.1826 54.1906 29.4278 54.114C29.6729 54.0375 29.937 54.1681 30.0172 54.4023Z",
    fill: "#D2982A"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_5401_7277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5685 73.827C70.2034 74.3547 69.8042 74.8398 69.364 75.3072C68.9238 75.7676 68.446 76.2031 67.9 76.5749C67.3541 76.9432 66.7364 77.2619 66.0096 77.3752C65.6479 77.4319 65.2623 77.439 64.8801 77.3575C64.4979 77.2796 64.1293 77.1238 63.7983 76.922L64.6719 75.6082C65.0132 75.9021 65.4192 76.0863 65.9072 76.0863C66.3918 76.0969 66.9275 75.9446 67.4428 75.7074C67.9581 75.4701 68.4597 75.1479 68.934 74.7867C69.4083 74.4255 69.869 74.0183 70.2853 73.5827L70.572 73.8235L70.5685 73.827Z",
    fill: "#909F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4118 75.2008C70.4118 75.2008 74.5339 78.5932 78.0624 75.3531C81.2325 72.4423 80.2531 64.9281 79.3147 62.3749C79.1612 61.9606 78.7858 61.6773 78.3592 61.6526C76.5984 61.5569 70.927 61.4755 67.1563 66.426C66.8049 66.8863 66.5694 67.4352 66.4875 68.0159C66.2759 69.5209 66.508 72.4423 70.4084 75.2008H70.4118Z",
    fill: "#FD473A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7108 72.3074C76.803 72.0914 77.0452 71.9887 77.2568 72.0843C77.4684 72.1799 77.5639 72.4314 77.4718 72.6509C77.3797 72.8669 77.1374 72.9696 76.9258 72.874C76.7177 72.7784 76.6187 72.527 76.7108 72.3074Z",
    fill: "#7E0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0047 68.5611C74.7795 68.5221 74.6293 68.299 74.6669 68.0653C74.7044 67.8316 74.9194 67.6758 75.1446 67.7148C75.3698 67.7537 75.52 67.9768 75.4824 68.2105C75.4449 68.4442 75.2299 68.6 75.0047 68.5611Z",
    fill: "#7E0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4896 70.8591C73.5818 70.6431 73.8241 70.5404 74.0322 70.636C74.2404 70.7316 74.3393 70.983 74.2472 71.199C74.1551 71.415 73.9128 71.5177 73.7012 71.4221C73.493 71.3265 73.3941 71.0751 73.4862 70.8591H73.4896Z",
    fill: "#7E0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4286 67.7217C71.5207 67.5057 71.763 67.403 71.9746 67.4986C72.1827 67.5942 72.2817 67.8456 72.1896 68.0652C72.0974 68.2847 71.8552 68.3839 71.6436 68.2883C71.4354 68.1926 71.3365 67.9412 71.4286 67.7252V67.7217Z",
    fill: "#7E0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8556 65.969C69.9477 65.753 70.19 65.6503 70.3982 65.7459C70.6063 65.8415 70.7053 66.0929 70.6132 66.3125C70.521 66.5285 70.2787 66.6312 70.0706 66.5356C69.8624 66.44 69.7635 66.1886 69.8556 65.969Z",
    fill: "#7E0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0282 66.9888C78.1204 66.7728 78.3626 66.6701 78.5742 66.7657C78.7858 66.8613 78.8813 67.1127 78.7892 67.3323C78.6971 67.5518 78.4548 67.651 78.2432 67.5554C78.0316 67.4598 77.9361 67.2083 78.0282 66.9923V66.9888Z",
    fill: "#7E0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0326 65.2111C73.1008 65.0447 73.2851 64.9703 73.4455 65.0412C73.6059 65.112 73.6775 65.3032 73.6093 65.4696C73.541 65.6361 73.3568 65.7104 73.1964 65.6396C73.036 65.5688 72.9644 65.3776 73.0326 65.2111Z",
    fill: "#7E0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4008 74.0392C74.469 73.8728 74.6533 73.7985 74.8137 73.8693C74.974 73.9401 75.0457 74.1313 74.9775 74.2977C74.9092 74.4642 74.7249 74.5385 74.5646 74.4677C74.4042 74.3969 74.3325 74.2057 74.4008 74.0392Z",
    fill: "#7E0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.984 69.7507C77.0523 69.5843 77.2365 69.5099 77.3969 69.5808C77.5573 69.6516 77.629 69.8428 77.5607 70.0092C77.4925 70.1757 77.3082 70.25 77.1478 70.1792C76.9874 70.1084 76.9158 69.9172 76.984 69.7507Z",
    fill: "#7E0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3471 68.5293C69.4153 68.3628 69.5996 68.2885 69.76 68.3593C69.9203 68.4301 69.992 68.6213 69.9238 68.7878C69.8555 68.9542 69.6712 69.0286 69.5109 68.9577C69.3505 68.8869 69.2788 68.6957 69.3471 68.5293Z",
    fill: "#7E0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8851 64.294C75.9534 64.1276 76.1377 64.0532 76.298 64.124C76.4584 64.1948 76.5301 64.3861 76.4618 64.5525C76.3936 64.7189 76.2093 64.7933 76.0489 64.7225C75.8886 64.6516 75.8169 64.4604 75.8851 64.294Z",
    fill: "#7E0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4495 74.6378L69.6269 78.8871C69.6269 78.8871 72.5752 78.4303 71.0431 74.6236L74.1825 74.4926C74.1825 74.4926 72.0258 73.2497 70.6609 73.2461C70.1422 73.2461 69.4529 74.6413 69.4529 74.6413L69.4495 74.6378Z",
    fill: "#909F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5585 74.7405L65.4636 74.914C65.4636 74.914 65.6547 71.8261 69.4391 73.0939L69.3026 69.836C69.3026 69.836 70.6778 71.9607 70.7972 73.3736C70.8416 73.9119 69.5585 74.7405 69.5585 74.7405Z",
    fill: "#909F11"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5401_7277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.047,
    height: 106,
    fill: "white",
    transform: "translate(0.116211)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5401_7277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.0952,
    height: 22.5847,
    fill: "white",
    transform: "translate(133.353 46.6122) rotate(135.865)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5401_7277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4341,
    height: 16.4341,
    fill: "white",
    transform: "translate(95.4341 8.21707)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_5401_7277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.279,
    height: 43.9805,
    fill: "white",
    transform: "translate(33.8062 11.4781) rotate(-24.6185)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_5401_7277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4341,
    height: 14.7907,
    fill: "white",
    transform: "translate(17.3721 21.4224) rotate(-53.4689)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_5401_7277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6114,
    height: 18.3268,
    fill: "white",
    transform: "translate(101.279 79.5432) rotate(60)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_5401_7277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.1587,
    height: 51.4103,
    fill: "white",
    transform: "translate(79.8052 105.344) rotate(165)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_5401_7277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6899,
    height: 21.3643,
    fill: "white",
    transform: "translate(4.6355 36.1551)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_5401_7277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4341,
    height: 17.2558,
    fill: "white",
    transform: "translate(63.7983 61.6279)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIllustration);
export default __webpack_public_path__ + "static/media/contact-illustration.5dcfaae1a67af61553d9d24c89311395.svg";
export { ForwardRef as ReactComponent };